import { render, staticRenderFns } from "./NewRFQRequest.vue?vue&type=template&id=e2c84348&scoped=true&"
import script from "./NewRFQRequest.vue?vue&type=script&lang=js&"
export * from "./NewRFQRequest.vue?vue&type=script&lang=js&"
import style0 from "./NewRFQRequest.vue?vue&type=style&index=0&id=e2c84348&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c84348",
  null
  
)

export default component.exports